// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"27":"3c5ac240","152":"78b9a4a0","188":"f5709543","601":"69cc25dd","777":"0d4f16ce","825":"57230ae3","985":"00469977"}[chunkId] + ".css";
};